import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { Button, Icon } from 'semantic-ui-react';

const AuthorisationButton = ({ platform, accessTokens, handleAuthClick, handleRemoveClick }) => {
  const isAuthorised = accessTokens && accessTokens[platform];
  const isYoutube = platform === 'youtube';
  const iconName = isYoutube ? 'youtube play' : platform;

  if (isAuthorised) {
    return (
      <Button size="huge" fluid color="red" basic onClick={handleRemoveClick}>
        <Icon name={iconName} />remove access
      </Button>
    );
  }

  if (isYoutube) {
    return (
      <Button size="big" fluid color="red" basic onClick={handleAuthClick}>
        <Icon name={iconName} />Continue with YouTube
      </Button>
    );
  }

  return (
    <Button size="big" fluid color={platform} onClick={handleAuthClick}>
      <Icon name={iconName} />Continue with {_.capitalize(platform)}
    </Button>
  );
};

AuthorisationButton.propTypes = {
  platform: PropTypes.string.isRequired,
  accessTokens: PropTypes.array.isRequired,
  handleAuthClick: PropTypes.func.isRequired,
  handleRemoveClick: PropTypes.func.isRequired,
};

export default AuthorisationButton;



/** WEBPACK FOOTER **
 ** ./src/components/authorisation-button/index.js
 **/